import Vue from 'vue'
import CONSTANT from '../constant/balance'

Vue.filter('balance_record_name', type => {
  switch (type) {
    case CONSTANT.BALANCE_RECORD_TYPE_CONSUMPTION:
      return '消费'
      break
    case CONSTANT.BALANCE_RECORD_TYPE_ROLLBACK:
      return '回滚'
      break
    case CONSTANT.BALANCE_RECORD_TYPE_REFUND:
      return '退费'
      break
    case CONSTANT.BALANCE_RECORD_TYPE_RECHARGE:
      return '充值'
      break
    case CONSTANT.BALANCE_RECORD_TYPE_WITHDRAW:
      return '提现'
      break
    default:
      return '-'
      break
  }
})

Vue.filter('balance_record_unit', amount => {
  return amount >=0 ? '+' : '-'
})
